import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import CardTitle from '../../common/CardTitle'
import { useTranslation } from 'react-i18next'
import BoxNumber from '../../common/BoxNumber'

function QuickStats({ data, selectedDuration }) {
  const { t } = useTranslation()
  const [statData, setStatData] = useState(null)
  const [currentDuration, setCurrentDuration] = useState('')
  useEffect(() => {
    if (selectedDuration) {
      setCurrentDuration(selectedDuration)
    }
    if (data && data[selectedDuration]) {
      setStatData(data[selectedDuration])
    }
  }, [data, selectedDuration])

  return statData ? (
    <div className={styles.quickStatsContainer}>
      <div className={styles.groupStats}>
        <div className={`${styles.largeBox} ${styles.mainBox}`}>
          <span className={styles.count}>{statData.group_count.value}</span>
          <span className={styles.name}>{t('global.groups')}</span>
        </div>

        <BoxNumber
          highlight={statData.group_memberships_per_member.value}
          text={t('dashboard.quickStats.groupsPerMember')}
          variation={statData?.group_memberships_per_member_variation?.value}
          image='stars-group'
          className={styles.largeBox}
        />

        <BoxNumber
          highlight={statData.public_group_ratio.value}
          text={t('dashboard.quickStats.publicGroups')}
          variation={statData?.public_group_ratio_variation?.value}
          image='stars-eye'
          className={styles.smallBox}
        />

        <BoxNumber
          highlight={statData.private_group_ratio.value}
          text={t('dashboard.quickStats.privateGroups')}
          variation={statData?.private_group_ratio_variation?.value}
          image='stars-private'
          className={styles.smallBox}
        />
      </div>
      <div className={styles.mixrStats}>
        <div className={`${styles.largeBox} ${styles.mainBox}`}>
          <span className={styles.count}>{statData.mixr_count.value}</span>
          <span className={styles.name}>{t('global.mixrs')}</span>
        </div>

        <BoxNumber
          highlight={statData.mixrs_joined_per_member.value}
          text={t('dashboard.quickStats.mixrsPerMember')}
          variation={statData?.mixrs_joined_per_member_variation?.value}
          image='stars-calendar'
          className={styles.largeBox}
        />

        <BoxNumber
          highlight={statData.recurring_mixr_ratio.value}
          text={t('dashboard.quickStats.recurringMixrs')}
          variation={statData?.recurring_mixr_ratio_variation?.value}
          image='stars-reccuring'
          className={styles.smallBox}
        />
        <BoxNumber
          highlight={statData.one_time_mixr_ratio.value}
          text={t('dashboard.quickStats.oneTimeMixrs')}
          variation={statData?.one_time_mixr_ratio?.value}
          image='stars-calendar'
          className={styles.smallBox}
        />
      </div>
    </div>
  ) : null
}

export default QuickStats
